module.exports = __webpack_public_path__ + "img/logo.90dc4468.png";